export const ROLE_MASTER_ADMIN = "masterAdmin";
export const ROLE_ADMIN = "admin"
export const ROLE_QUALITY = "qa";
export const ROLE_DOCTOR = "doctor";
export const ROLE_MEDIC = "medic";
export const ROLE_MEDICAL_DIRECTOR = "medicalDirector";

interface Roles {
  roles: string[]
}

interface ClientRoles extends Roles {
  clientID: number
}

interface LocationRoles extends Roles {
  locationID: number
}

interface AuthRoler {
  global: Roles
  clients: ClientRoles[]
  locations: LocationRoles[]


  hasAnyRole(roles: string[], clientID?: number, locationID?: number,): boolean

  hasGlobalRole(role: string): boolean

  hasGlobalRoles(roles: string[]): boolean

  hasRoles(roles: string[]): boolean
}

type AuthRoleParams = {
  global?: Roles,
  clients?: ClientRoles[],
  locations?: LocationRoles[]
}

export class AuthRoles implements AuthRoler {
  global: Roles
  clients: ClientRoles[]
  locations: LocationRoles[]

  constructor(params?: AuthRoleParams) {
    if (!params) {
      params = {}
    }
    this.global = params.global || {roles: []};
    this.clients = params.clients || [];
    this.locations = params.locations || [];
  }

  public hasRoles(roles: string[]): boolean {
    return this.hasAnyGlobalRole(roles) || this.hasClientRoles(roles) || this.hasLocationRoles(roles);
  }

  public hasGlobalRole(role: string): boolean {
    return this.global.roles.includes(role)
  }

  public hasGlobalRoles(roles: string[]): boolean {
    return this.global.roles.some(r => roles.includes(r))
  }

  public hasAnyRole(roles: string[], clientID?: number, locationID?: number): boolean {
    return this.hasAnyGlobalRole(roles)
      || this.hasAnyClientRole(roles, clientID)
      || this.hasAnyLocationRole(roles, locationID)
  }

  private hasClientRoles(roles: string[]): boolean {
    return this.clients.some(c => c.roles.some(r => roles.includes(r)))
  }

  private hasLocationRoles(roles: string[]): boolean {
    return this.locations.some((l) => l.roles.some((r) => roles.includes(r)))
  }

  private hasAnyClientRole(roles: string[], clientID?: number): boolean {
    if (!clientID) {
      return false
    }
    const client: ClientRoles | undefined = this.clients.find(c => c.clientID === clientID)
    if (!!client) {
      return client.roles.some(r => roles.includes(r))
    }
    return false
  }

  private hasAnyLocationRole(roles: string[], locationID?: number): boolean {
    if (!locationID) {
      return false
    }
    const location: LocationRoles | undefined = this.locations.find(l => l.locationID === locationID)
    if (!!location) {
      return location.roles.some(r => roles.includes(r))
    }
    return false
  }

  private hasAnyGlobalRole(roles: string[]) {
    return this.global.roles.some(r => roles.includes(r))
  }
}

